// The two sort chips of a variety listing: they swap the A to Z grid for the
// grouped view and nothing else. The colour chips, the count and the empty
// line stay where they are, because a colour filters both views;
// assets/variety-filter.js recounts when it hears the event sent below.
document.querySelectorAll('[data-variety-filter-root]').forEach((root) => {
  const views = root.querySelector('[data-variety-views]');
  const season = root.querySelector('[data-variety-season]');
  if (!views || !season) return;
  // The grouped view holds grids of its own, so the A to Z grid is the one
  // outside it.
  const grid = Array.from(root.querySelectorAll('[data-variety-grid]')).find((el) => !season.contains(el));
  if (!grid) return;

  views.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-view-pick]');
    if (!btn) return;
    const byName = btn.dataset.viewPick === 'name';
    views.querySelectorAll('[data-view-pick]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    grid.style.display = byName ? '' : 'none';
    season.hidden = byName;
    season.style.display = byName ? 'none' : '';
    root.dispatchEvent(new CustomEvent('variety:view'));
  });
});
